module.exports = __webpack_public_path__ + "img/title-2.1728f728.png";